import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

import Cell from "./Cell";
import Group from "./Group";

const StyledRow = styled.div`
  display: flex;
  min-height: 40px;
  align-items: center;
  border-bottom: 1px solid #ecedf1;
  ${({ index }) =>
    index % 2 !== 0 &&
    css`
      background-color: #fafaff;
    `}
`;

function Row({ row, columns, index }) {
  return (
    <StyledRow index={index}>
      {columns.map(({ key, width, ...props }, idx) => {
        if (Array.isArray(key))
          return (
            <Group key={`group_${idx}`} width={width}>
              {key.map(({ key: k, ...kProps }, groupRowIdx) => (
                <Cell key={`${index}_${groupRowIdx}_${k}`} width={width} {...props} {...kProps}>
                  {row[k]}
                </Cell>
              ))}
            </Group>
          );

        return (
          <Cell key={idx} width={width} {...props} {...row}>
            {row[key]}
          </Cell>
        );
      })}
    </StyledRow>
  );
}

Row.propTypes = {
  row: PropTypes.object,
  columns: PropTypes.array,
  index: PropTypes.number,
};

export default Row;
